import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getCustomers = (application) => {
  return clientHTTP.getAll(getLinkHref(application, 'customers'))
}

const getCustomerAllFleets = (customer) => {
  return clientHTTP.getAll(getLinkHref(customer, 'fleets'), { sort: '+name' })
}

const getCustomerAllClusters = (customer) => {
  return clientHTTP.getAll(getLinkHref(customer, 'clusters'), { sort: '+name' })
}

const createCustomer = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'customers'), params)
}

const patchCustomer = (customer, params = {}) => {
  return clientHTTP.patch(getLinkHref(customer, 'self'), params)
}

const deleteCustomer = (customer) => {
  return clientHTTP.delete(getLinkHref(customer, 'self'))
}

export default {
  getCustomers,
  getCustomerAllFleets,
  getCustomerAllClusters,
  createCustomer,
  patchCustomer,
  deleteCustomer
}
